import { Check } from "lucide-react"
import { cn } from "@/shared/lib/utils"

export interface ReadinessCheck {
	label: string
	done: boolean
	/** Без этого материал не сохранить; остальное только советы. */
	required?: boolean
	/** Куда вести по клику: id секции редактора. */
	target?: string
}

/** Что ещё стоит заполнить, прежде чем публиковать. Клик ведёт к нужному блоку. */
export function Readiness({ checks }: { checks: ReadinessCheck[] }) {
	const done = checks.filter((check) => check.done).length
	return (
		<section className="rounded-2xl border border-border bg-card p-4" aria-label="Готовность">
			<div className="mb-3 flex items-center justify-between gap-3">
				<h2 className="text-sm font-medium">Готовность к публикации</h2>
				<span className="text-xs text-muted-foreground tabular-nums">
					{done} из {checks.length}
				</span>
			</div>
			<div className="mb-3 h-1 overflow-hidden rounded-full bg-secondary">
				<div
					className="h-full rounded-full bg-emerald-400 transition-[width] duration-300 ease-[var(--ease-out-soft)]"
					style={{ width: `${(done / checks.length) * 100}%` }}
				/>
			</div>
			<ul className="space-y-0.5">
				{checks.map((check) => (
					<li key={check.label}>
						<button
							type="button"
							onClick={() =>
								check.target &&
								document.getElementById(check.target)?.scrollIntoView({ behavior: "smooth" })
							}
							className="flex w-full items-center gap-2.5 rounded-lg px-1.5 py-1.5 text-left text-sm transition-colors hover:bg-accent/50"
						>
							<span
								className={cn(
									"grid size-4.5 shrink-0 place-items-center rounded-full border transition-colors",
									check.done
										? "border-emerald-400 bg-emerald-400 text-background"
										: check.required
											? "border-primary"
											: "border-muted-foreground/40",
								)}
							>
								{check.done ? <Check className="size-3" strokeWidth={3} /> : null}
							</span>
							<span className={check.done ? "text-muted-foreground" : "text-foreground"}>
								{check.label}
							</span>
							{!check.done && check.required ? (
								<span className="ml-auto text-[11px] text-primary">обязательно</span>
							) : null}
						</button>
					</li>
				))}
			</ul>
		</section>
	)
}
